import { SellingOffersNegotiationData } from '@interfaces/models/negotiation/domain/SellingOffersNegotiation';
import SellingOffersNegotiationsListCard from '../selling-offers-negotiations-list-card/selling-offers-negotiations-list-card';

interface SellingOffersNegotiationsListProps {
  negotiationsList: SellingOffersNegotiationData[];
  refetch?: () => void;
}

const SellingOffersNegotiationsList: React.FC<SellingOffersNegotiationsListProps> = ({ negotiationsList, refetch }) => {
  return (
    <>
      <ul>
        {negotiationsList.map((item) => (
          <SellingOffersNegotiationsListCard
            key={item.id}
            negotiation={item}
            refetch={refetch}
          />
        ))}
      </ul>
    </>
  );
};

export default SellingOffersNegotiationsList;
